import { getFlag } from 'sierra-client/config/global-config'

export const useLiveQuizEnabled = (): boolean => getFlag('live-quiz')
